import { Component, Injector } from '@angular/core';
import { SupportComponentBase } from '@app/support/component-base.component';
import { appModuleAnimation } from '@shared/animations/routerTransition';

@Component({
    selector: 'support-quicklink-error',
    templateUrl: './support-quicklink-error.component.html',
    animations: [appModuleAnimation()],
})
export class SupportQuickLinkErrorComponent extends SupportComponentBase {
    public constructor(injector: Injector) {
        super(injector);
    }
}
